<!--
 * @Description:详情卡片
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-02-24 15:17:46
 * @LastEditors: cxh
-->
<template>
  <dc-layout-card :title="title" :span="span">
    <template #subTitle>
      <slot name="subTitle"></slot>
    </template>
    <dc-form-item
      v-for="(item, i) in columnsComputed"
      :key="i"
      :span="item.span || span"
      :name="item.dataIndex"
      :label="item.title"
    >
      <slot name="bodyCell" :text="data[item.dataIndex]" :record="data" :index="i" :column="item">
        <component :is="item.node" v-bind="item.attrs" :value="data[item.dataIndex]" :disabled="item.disabled" view />
      </slot>
    </dc-form-item>
  </dc-layout-card>
</template>
<script lang="ts">
import { computed } from 'vue'
import type { PropType } from 'vue'
export default { name: 'DetailCard' }
</script>
<script setup lang="ts">
interface ColumnType {
  title: string
  dataIndex: string
  node: string // 默认a-input
  disabled: boolean
  span: number
}
const props = defineProps({
  columns: {
    type: Array as PropType<ColumnType[]>,
    default: () => []
  },
  data: {
    type: Object,
    default: () => null
  },
  disabled: {
    type: Boolean,
    default: true // 是否表单不可选择
  },
  span: {
    type: Number,
    default: 6
  },
  title: {
    type: String,
    default: ''
  }
})
// 处理Column
// 重新定义列描述数据对象
const columnsComputed = computed(() => {
  const result = props.columns.map((item: ColumnType) => {
    item.disabled = item.disabled === undefined ? props.disabled : item.disabled
    item.node = item.node || 'cos-input'
    return item
  })
  return result
})
</script>
